import { outcomeForReduxAction, reportTutorialActionResult } from './tutorialOutcomes';

/**
 * Turns the redux actions the app already dispatches into tutorial outcomes.
 *
 * The single producer for `onTutorialActionResult`. Middleware rather than
 * `store.subscribe` because the question is "which action just settled", and a
 * subscriber only sees that state changed — several of these outcomes are not
 * distinguishable from the resulting state at all (an archive that matched no
 * records looks exactly like one that was never requested).
 *
 * Runs AFTER `next(action)` so subscribers see a store the reducers have already
 * updated, and synchronously within the dispatch so a completion is recorded
 * before a taught action's own navigation tears the page down.
 */
const tutorialOutcomeMiddleware = () => (next) => (action) => {
  const result = next(action);

  const outcome = outcomeForReduxAction(action);
  if (outcome) reportTutorialActionResult(outcome.action, outcome.success);

  return result;
};

export default tutorialOutcomeMiddleware;
